<template>
  <ViewWrapper id="quotes" :title="t('quotes.pageTitle')" class="w-100">
    <div class="mt-4">
      <template v-if="isLoading">
        <QuoteSkeleton class="mb-2" />
      </template>
      <template v-else-if="error">
        <p class="error-message">{{ t('errorMessages.fetchBookings') }}</p>
      </template>
      <template v-else>
        <BookingList
          :bookings="updatedBookings.quotes.value"
          empty-title-key="quotes.noQuote"
          empty-description-key="quotes.timeToChoose"
        />
      </template>
    </div>
  </ViewWrapper>
</template>

<script setup lang="ts">
  import { useBookings } from '@/composables/useBookings'
  import { useI18n } from 'vue-i18n'
  import { computed, onMounted } from 'vue'

  // VUE Components
  import ViewWrapper from '@/components/UI/ViewWrapper.vue'
  import BookingList from '@/components/common/BookingList.vue'
  import QuoteSkeleton from '@/components/Quotes/QuoteSkeleton.vue'
  import store from '@/store'

  // Translations
  const { t } = useI18n()

  // Bookings Map
  const bookingsMap = {
    quotes: computed(() => store.getters['booking/quotesAndCartInProgress']),
  }

  const {
    isLoading,
    error,
    updatedBookings,
    fetchAndMapBookings,
    openPanelByRef,
  } = useBookings(bookingsMap)

  onMounted(async () => {
    await fetchAndMapBookings()
    openPanelByRef()
  })
</script>
